import {
  BotButtonPayloadType,
  IButtonSelectedRequestData,
  IBotButtonApiModel,
  ICommandPayload,
} from '@gem/models/botModel';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { CommandButtonPayload } from '../ButtonsPayload/CommandButtonPayload';
import { Payload } from '../Payload';

interface IButtonsSelectedPayloadParams {
  button: IBotButtonApiModel;
}

export class ButtonsSelectedPayload extends Payload {
  id: string;
  title: string;
  payload: CommandButtonPayload | null;

  constructor(data: IButtonsSelectedPayloadParams) {
    super({ ...data, payloadType: PayloadType.ButtonsSelected });

    this.id = data.button.id;
    this.title = data.button.title;
    this.payload = null;
    switch (data.button.payload?.type) {
      case BotButtonPayloadType.Command: {
        this.payload = new CommandButtonPayload(data.button.payload as ICommandPayload);
        break;
      }
    }
  }

  toJSON(): IButtonSelectedRequestData {
    return {
      ...super.toJSON(),
      button: {
        id: this.id,
        title: this.title,
        payload: this.payload?.toJSON(),
      },
    };
  }

  get text(): string {
    return this.title;
  }
}
